import React from 'react'

const EmpDashboard = () => {
    return (
        <div>EmpDashboard</div>
    )
}

export default EmpDashboard        